import axios from './axiosInstance.js'
import apiList from './apiList.js'

let apiObj = {};
/*
 * 单页面所有接口管理模块，因为暂时只有一个，暂时写在axios.js
 */

//apiList所有API
for (let key in apiList) {
    apiObj[key] = data => {
        const arr = key.split("_");
        const type = arr[0];
        /*一个接口多个URL，但是请求数据 和响应数据一样，
        将 apiModules文件夹里api属性这些写：POST_selectApe:{selectApe:'/motorvehicle/selectApe',getTjTreeList:"/ape/getTjTreeList/" + dictCode,selectTollgate:"/motorvehicle/selectTollgate"}
        然后每次调用前先将属性名切换一下就能拿到URL了，什么都不用改
        const urlName =store.state.selectCardAPIname  //留这里预防后期会用到这种方式
        */
        let body = {
            // url:apiList[key][urlName],  //让上面vuex切换 url
            url: apiList[key],
            method: type
        };
        if (data) {

            if (data.params) {

                body.params = data.params
            } else if (data.paramsID) {
                body.url += `${data.paramsID}`;

            } else {

            }
            body.data = data
        }
        return axios(body)
    }
}

export default apiObj


// WEBPACK FOOTER //
// ./src/http/axios.js